import { Box, Typography } from "@mui/material";
import { T } from "./tokens";

/**
 * Shown when /weeklyvisitsummary returns null — the signed-in user is not flagged
 * H&S Admin in Salesforce, which gates the org-wide data server-side.
 */
export const HsAdminGate = () => (
    <Box sx={{ padding: "48px 28px", display: "flex", justifyContent: "center" }}>
        <Box
            sx={{
                background: T.card,
                border: `1px dashed ${T.border}`,
                borderRadius: "12px",
                padding: "36px 32px",
                maxWidth: "520px",
                textAlign: "center",
            }}
        >
            <Box
                sx={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "50%",
                    background: T.amberTint,
                    color: T.amber,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                    margin: "0 auto 14px",
                }}
            >
                🔒
            </Box>
            <Typography sx={{ fontSize: "16px", fontWeight: 700, color: T.ink2 }}>
                H&amp;S Admin access required
            </Typography>
            <Typography sx={{ fontSize: "13.5px", color: T.muted, mt: "8px", lineHeight: 1.5 }}>
                The org-wide consultants and schedule data comes from the weekly visit summary, which
                the API returns only to users who are both flagged <b>H&amp;S Admin</b> in Salesforce
                and hold a recognised H&amp;S consultant job title. Your own visits on the Overview
                don't need this — the Overview KPI headline uses the same two checks.
            </Typography>
        </Box>
    </Box>
);
